import React, { useState, useEffect, useRef, useMemo } from 'react';
import './blocks.scss';
import { nxtdash_fetch_api, appendFormData, nxtdash_save_data } from '../../apicall';
import NosearchHtml from '../nosearch/nosearch'
import { __ } from '@wordpress/i18n';
import { ToastContainer, toast, Slide } from 'react-toastify';
import { nxtInstallCall } from '../../apicall';

const plugin_url = nxtext_ajax_object.nxtex_url || nxtext_ajax_object.tpgb_url;
const blockCate = [__('Essential', 'nexter-extension'), __('Creative', 'nexter-extension'), __('Tabbed', 'nexter-extension'), __('Social', 'nexter-extension'), __('Advanced', 'nexter-extension'), __('Listing', 'nexter-extension'), __('Builder', 'nexter-extension'), __('Extras', 'nexter-extension'), __('WDesignKit', 'nexter-extension')];

const Blocks = ({ isPopupVisible, setIsPopupVisible, setIsAfterWDKPopupVisible, setIsWDKPopupVisible, setSelectedWUnique, setwdBlockID, isAfterWDKPopupVisible, props, CustomSuccessToast = () => { }, setIsPopupType, isPopupType }) => {
    const [filterTag, setfilterTag] = useState('All');
    const [filterCate, setfilterCate] = useState('Essential');
    const [searchBlock, setsearchBlock] = useState('');

    const [blockStates, setBlockStates] = useState(() => {
        const initialState = {};
        if (nxtext_ajax_object.dashData && nxtext_ajax_object.dashData.blockList) {
            Object.keys(nxtext_ajax_object.dashData.blockList).forEach((block) => {
                initialState[block] = nxtext_ajax_object.dashData.enableBlock.includes(block);
            });
        }
        return initialState;
    });

    const [unusedBlocksCount, setUnusedBlocksCount] = useState(null);
    const [usageData, setUsageData] = useState({});
    const [isDragging, setIsDragging] = useState(false);
    const [dragStartX, setDragStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const stripRef = useRef(null);
    const [WshowPopup, WsetShowPopup] = useState(false);
    const [wdkloader, setwdkloader] = useState(false);
    const [update_wdk, setupdate_wdk] = useState(false);
    const [wdk_filtered_widget, setwdk_filtered_widget] = useState([]);
    const openProPopup = () => setIsPopupVisible(true);
    const openWDKPopup = () => setIsWDKPopupVisible(true);
    const [toggleUpdate, setToggleUpdate] = useState(false);
    const [tpgbinstall, setTpgbinstall] = useState(nxtext_ajax_object?.dashData?.tpgbinstall || false);

    const handleTagClick = (tag) => {
        setfilterTag(tag);
    };

    let wdadded = nxtext_ajax_object.dashData.wdadded;

    useEffect(() => {
        const handleMouseMove = (event) => {
            if (!isDragging) return;
            const deltaX = event.clientX - dragStartX;
            stripRef.current.scrollLeft = scrollLeft - deltaX;
        };

        const handleMouseUp = () => {
            setIsDragging(false);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, dragStartX, scrollLeft]);

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const updatedState = {};

        const timeoutId = setTimeout(() => {
            if (nxtext_ajax_object.dashData && nxtext_ajax_object.dashData.blockList) {
                Object.keys(nxtext_ajax_object.dashData.blockList).forEach((blockId) => {
                    const block = nxtext_ajax_object.dashData.blockList[blockId];

                    if (!((nxtext_ajax_object.pro && nxtext_ajax_object.tpgb_pro == undefined) || (nxtext_ajax_object.tpgb_pro == "1")) && block.tag === 'pro') {
                        updatedState[blockId] = false;
                    } else {
                        updatedState[blockId] = nxtext_ajax_object.dashData.enableBlock.includes(blockId);
                    }
                });
            }
            setBlockStates(updatedState);
            setIsLoading(false);
        }, 0);

        return () => clearTimeout(timeoutId);

    }, [nxtext_ajax_object.dashData.enableBlock, nxtext_ajax_object.dashData.blockList, nxtext_ajax_object.pro, nxtext_ajax_object.tpgb_pro]);

    const handleMouseDown = (event) => {
        setIsDragging(true);
        setDragStartX(event.clientX);
        setScrollLeft(stripRef.current.scrollLeft);
    };

    const handleCategoryClick = (category) => {
        setfilterCate(category);

        const categorySection = document.getElementById(`${category.toLowerCase()}`);
        if (categorySection) {
            categorySection.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });

            const yOffset = -250;
            const y = categorySection.getBoundingClientRect().top + window.scrollY + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    const handleSearchChange = (event) => {
        setsearchBlock(event.target.value);
    };

    const allEnabled = useMemo(() => {
        if (!blockStates || Object.keys(blockStates).length === 0) {
            return false;
        }
        
        if (!((nxtext_ajax_object.pro && nxtext_ajax_object.tpgb_pro == undefined) || (nxtext_ajax_object.tpgb_pro == "1"))) {
            return Object.keys(blockStates)
                .filter(blockId => {
                    const blockData = nxtext_ajax_object.dashData.blockList[blockId];
                    const isFree = blockData.tag.includes('free');
                    const isNotWDesignKit = blockData?.block_cate !== 'WDesignKit';
                    return isFree && isNotWDesignKit;
                })
                .every(blockId => blockStates[blockId] === true);
        }
        
        return Object.keys(blockStates)
            .filter(blockId => {
                const blockData = nxtext_ajax_object.dashData.blockList[blockId];
                return blockData?.block_cate !== 'WDesignKit';
            })
            .every(blockId => blockStates[blockId] === true);
    }, [blockStates]);

    const saveBlockStates = async (e, updatedStates) => {
        const updatedBlockStates = Object.keys(updatedStates).reduce((acc, blockId) => {
            if (updatedStates[blockId]) {
                acc.push(blockId);
            }
            return acc;
        }, []);

        const currentEnabledBlocks = Object.keys(updatedStates).filter(blockId => updatedStates[blockId]);

        const enabledPlusBlocks = currentEnabledBlocks.filter(blockId =>
            nxtext_ajax_object.dashData.blockList[blockId].block_cate === 'Extras'
        );

        const enabledextStates = enabledPlusBlocks.reduce((obj, blockId) => {
            obj[blockId] = true;
            return obj;
        }, {});

        await nxtdash_save_data(e, {
            action: 'tpgb_blocks_opts_save',
            'submit-key': 'Save',
            'enable_normal_blocks': JSON.stringify(updatedBlockStates),
            'tp_extra_option': JSON.stringify(Object.keys(enabledextStates)),
            'nonce_tpgb_normal_blocks_opts': nxtext_ajax_object.tpgb_nonce || nxtext_ajax_object.ajax_nonce,
        });

        // After save completes, update the local state
        setBlockStates((prevStates) => ({
            ...prevStates,
            ...updatedBlockStates.reduce((acc, blockId) => {
                acc[blockId] = true; // Mark these blocks as enabled
                return acc;
            }, {}),
        }));

        toast(<CustomSuccessToast />, {
            position: "top-right",
            autoClose: 800,
            limit: 1,
            closeOnClick: true,
            closeButton: false,
            pauseOnHover: false,
            hideProgressBar: true,
            transition: Slide,
            className: 'nxt-blocks-success-toast',
        });
    };

    const handleToggleAll = async (e) => {
        const newState = !allEnabled;
        const updatedBlockStates = {};

        if ( ! ( (nxtext_ajax_object.pro && nxtext_ajax_object.tpgb_pro == undefined) || (nxtext_ajax_object.tpgb_pro == "1") ) && nxtext_ajax_object.dashData.blockList) {
            Object.keys(nxtext_ajax_object.dashData.blockList).forEach((blockId) => {
                const blockData = nxtext_ajax_object.dashData.blockList[blockId];
                const isFree = blockData.tag.includes('free');
                const isWDesignKit = blockData?.block_cate === 'WDesignKit';
                
                if (isFree && !isWDesignKit) {
                    updatedBlockStates[blockId] = newState;
                } else {
                    updatedBlockStates[blockId] = false; 
                }
            });
        } else {
            Object.keys(blockStates).forEach((blockId) => {
                const blockData = nxtext_ajax_object.dashData.blockList[blockId];
                const isWDesignKit = blockData?.block_cate === 'WDesignKit';
                
                if (!isWDesignKit) {
                    updatedBlockStates[blockId] = newState;
                } else {
                    updatedBlockStates[blockId] = false; 
                }
            });
        }

        setBlockStates(updatedBlockStates);
        await saveBlockStates(e, updatedBlockStates);
    };

    const handleToggleBlock = async (e, blockId) => {
        const block = nxtext_ajax_object.dashData.blockList[blockId];
        if (!((nxtext_ajax_object.pro && nxtext_ajax_object.tpgb_pro == undefined) || (nxtext_ajax_object.tpgb_pro == "1")) && block.tag === 'pro') {
            return;
        }

        const updatedStates = {
            ...blockStates,
            [blockId]: !blockStates[blockId],
        };
        setBlockStates(updatedStates);
        await saveBlockStates(e, updatedStates);
    };

    const handleScanUnusedBlocks = async (e) => {
        let form = new FormData();
        const formData = {
            action: 'tpgb_is_block_used_not',
            nonce: nxtext_ajax_object.tpgb_nonce || nxtext_ajax_object.ajax_nonce,
            default_block: false
        };
        appendFormData(form, formData);
        e.target.innerHTML = 'Scanning...'
        try {
            const response = await nxtdash_fetch_api(form);
            const data = await response

            if (data) {
                const blockList = nxtext_ajax_object?.dashData?.blockList || {};
                const isProActive = !!nxtext_ajax_object?.pro; // true = Pro active

                let finalData = data;

                if (!isProActive) {
                    finalData = Object.entries(data)
                        .filter(([blockSlug]) => {
                            const tag = blockList[blockSlug]?.tag;
                            return tag === "free" || tag === "freemium";
                        })
                        .reduce((acc, [key, value]) => {
                            acc[key] = value;
                            return acc;
                        }, {});
                }
    
                setUsageData(finalData);

                const unusedBlocks = Object.values(finalData).filter(usedTimes => usedTimes == 0).length;
                setUnusedBlocksCount(unusedBlocks);
                e.target.innerHTML = 'Scan Unused Blocks'
            }

        } catch (error) {
            console.error('Error scanning unused blocks:', error);
        }
    };

    const handledisableUnused = async (e) => {
        let form = new FormData();
        const formData = {
            action: 'tpgb_unused_disable_block',
            nonce: nxtext_ajax_object.tpgb_nonce || nxtext_ajax_object.ajax_nonce,
            blocks: JSON.stringify(usageData),
            default_block: false
        };
        appendFormData(form, formData);
        e.target.innerHTML = 'Disabling Unused Blocks..'
        try {
            const response = await nxtdash_fetch_api(form);
            const data = await response

            if (data) {
                let activeCount = 0;
                // Run this only if Free version is activated
                activeCount = Object.values(usageData).filter(v => v === 1).length;
                
                nxtext_ajax_object.dashData.avtiveBlock = activeCount;
                window.location.reload();
            }

        } catch (error) {
            console.error('Error scanning unused blocks:', error);
        }
    };

    const filterBlocks = (block) => {
        const tagMatch = filterTag === 'All' || block.tag === filterTag;
        const searchMatch = block.label.toLowerCase().includes(searchBlock.toLowerCase());
        const keywordMatch = block.keyword ? block.keyword.some(keyword => keyword.toLowerCase().includes(searchBlock.toLowerCase())) : false;
        return tagMatch && (searchMatch || keywordMatch);

    };

    const getCategoryCounts = (category) => {
        const filteredBlocks = Object.keys(nxtext_ajax_object.dashData.blockList).filter(blockId => {
            const block = nxtext_ajax_object.dashData.blockList[blockId];
            const tagMatch = filterTag === 'All' || block.tag === filterTag;
            const searchMatch = block.label.toLowerCase().includes(searchBlock.toLowerCase());

            return block.block_cate === category && tagMatch && searchMatch;
        });

        const totalBlocks = filteredBlocks.length;

        const activeBlocks = filteredBlocks.reduce((actcount, blockId) => {
            const block = nxtext_ajax_object.dashData.blockList[blockId];
            if (category === "WDesignKit") {
                return actcount + (block.w_type && block.w_type === "Publish" ? 1 : 0);
            } else {
                return actcount + (blockStates[blockId] ? 1 : 0);
            }
        }, 0);

        return { totalBlocks, activeBlocks };
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (event.target != 'nxt-dashsu-toggle' && !event.target.closest('.nxt_whitlabel_popup') && !event.target.closest('.nxt_block_inner_toggle')) {
                setIsPopupVisible(false);
            }
        };

        const handleEscapeKey = (event) => {
            if (event.key === 'Escape') {
                setIsPopupVisible(false);
            }
        };

        document.body.addEventListener('click', handleClickOutside);
        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.body.removeEventListener('click', handleClickOutside);
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, []);

    const proModel = () => {
        setIsPopupVisible(true)
        setIsPopupType('blocks')
    }



    const hasResults = blockCate.some((category) => {
        return (nxtext_ajax_object?.dashData?.blockList) ? Object.keys(nxtext_ajax_object.dashData.blockList)
            .some(blockId => filterBlocks(nxtext_ajax_object.dashData.blockList[blockId]) && nxtext_ajax_object.dashData.blockList[blockId].block_cate === category) : false;
    });

    let downloadSVG = <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" fill="none"><path fill="#19191B" d="M6.791.036a.695.695 0 0 0-.201.136c-.188.187-.176-.054-.176 3.386V6.62l-.474-.474c-.506-.504-.596-.567-.79-.57a.542.542 0 0 0-.418.176.537.537 0 0 0-.124.657c.028.063.312.363.894.943.764.76.87.855 1.005.919.312.145.655.147.974.01.124-.057.236-.158 1.005-.92.634-.628.877-.886.91-.961a.647.647 0 0 0 .007-.46.62.62 0 0 0-.539-.363c-.211.002-.29.058-.802.57l-.476.473V3.558c0-3.44.012-3.199-.176-3.386a.584.584 0 0 0-.619-.136Z" /><path fill="#19191B" d="M1.374 5.452a.615.615 0 0 0-.343.36c-.035.107-.04.173-.025.454a5.942 5.942 0 0 0 1.003 3.067 6.35 6.35 0 0 0 1.825 1.766 6.015 6.015 0 0 0 5.409.469 5.849 5.849 0 0 0 2.059-1.398 5.912 5.912 0 0 0 1.693-3.909c.016-.394-.014-.518-.17-.673a.575.575 0 0 0-.82 0c-.129.13-.169.258-.185.622a4.724 4.724 0 0 1-.157 1.031 4.848 4.848 0 0 1-3.522 3.447 4.832 4.832 0 0 1-5.82-3.503 5.537 5.537 0 0 1-.152-1.107c0-.218-.054-.368-.176-.49a.584.584 0 0 0-.62-.136Z" /></svg>;

    const Handle_widget = (status, id, name) => {
        const wd_type = status ? 'Publish' : 'Draft';

        let blockList = nxtext_ajax_object.dashData.blockList || {};
        Object.keys(blockList).forEach(widgetKey => {
            const widget = blockList[widgetKey];
            if (widget?.block_cate === "WDesignKit" && widget.uniqueId === id) {
                blockList[widgetKey].w_type = wd_type;
            }
        });
        nxtext_ajax_object.dashData.blockList = blockList;
        setToggleUpdate(prev => !prev);

        if (wd_type === "Publish" || wd_type === "Draft") {
            toast(<CustomSuccessToast />, {
                position: "top-right",
                autoClose: 800,
                limit: 1,
                closeOnClick: true,
                closeButton: false,
                pauseOnHover: false,
                hideProgressBar: true,
                transition: Slide,
                className: 'nxt-blocks-success-toast',
            });
        }

        setTimeout(async () => {
            let form = new FormData();
            const formData = {
                action: 'nxt_wdk_widget_ajax_call',
                type: 'wdk_update_widget',
                p_type: wd_type,
                w_unique: id,
                w_name: name
            };
            appendFormData(form, formData);

            try {
                const response = await nxtdash_fetch_api(form);
                if (!response.success) {
                    console.error("API Error:", response);
                    blockList = nxtext_ajax_object.dashData.blockList || {};
                    Object.keys(blockList).forEach(widgetKey => {
                        const widget = blockList[widgetKey];
                        if (widget?.block_cate === "WDesignKit" && widget.uniqueId === id) {
                            blockList[widgetKey].w_type = status ? 'Draft' : 'Publish';
                        }
                    });
                    nxtext_ajax_object.dashData.blockList = blockList;
                }
            } catch (error) {
                console.error("API Call Failed:", error);
            }
        }, 1000);
    };

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const offset = 300; // Adjust this value based on your header height and preference

            // Get all category sections
            const sections = blockCate.map(category => ({
                name: category,
                element: document.getElementById(category.toLowerCase())
            })).filter(section => section.element);

            // Find which section is currently in view
            let activeSection = null;

            for (let i = 0; i < sections.length; i++) {
                const section = sections[i];
                const rect = section.element.getBoundingClientRect();
                const sectionTop = rect.top + window.scrollY;

                // Check if section is in viewport (considering offset)
                if (scrollY + offset >= sectionTop) {
                    activeSection = section.name;
                } else {
                    break;
                }
            }

            // Update active category if it's different from current
            if (activeSection && activeSection !== filterCate) {
                setfilterCate(activeSection);
            }
        };

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Cleanup function
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [blockCate, filterCate]);

    const features = [
        "1000+ Ready-to-Import templates & sections",
        "No coding required – perfect for beginners & pros",
        "Built on WordPress Core Block Editor (no extra builder needed)",
        "jQuery-free with smart CSS & JS loading for speed",
        "Lightweight yet powerful – design without compromise",
    ];

    return (
        <>
            <div className={'nxt_blocks_inner_main nxtext_main_container'}>
                <div className='nxtext_section_heading_cover'>
                    <h3 className='nxtext_primary_heading'>{__('Blocks', 'nexter-extension')}</h3>
                    {tpgbinstall &&
                        <div className='nxt_header_toggle_btn_group'>
                            <div className='nxt_block_manage_toggle_cover'>
                                <span className='toggle_text'>{__('Disable All', 'nexter-extension')}</span>
                                <div className="nxt_block_toggle_btn_cover">
                                    <input
                                        className="nxt_toggle_btn"
                                        type="checkbox"
                                        checked={allEnabled}
                                        onChange={(e) => handleToggleAll(e)}
                                        id="toggle-all"
                                    />
                                    <label className="switch-label" htmlFor="toggle-all">
                                        <span className="switch-button"></span>
                                    </label>
                                </div>
                                <span className='toggle_text'>{__('Enable All', 'nexter-extension')}</span>
                            </div>
                        </div>
                    }
                </div>
                {tpgbinstall ?
                <>
                <div className='nxt_block_categories'>
                    <div className='the_plus_categories_strip_cover_main'>
                        <div className='nxt_categories_btns_cover'>
                            <a className={`nxt_category_btn ${filterTag === 'All' ? 'nxt_active' : ''}`} onClick={() => handleTagClick('All')}>{__('All', 'nexter-extension')}</a>
                            <a className={`nxt_category_btn ${filterTag === 'free' ? 'nxt_active' : ''}`} onClick={() => handleTagClick('free')}>{__('Free', 'nexter-extension')}</a>
                            <a className={`nxt_category_btn ${filterTag === 'freemium' ? 'nxt_active' : ''}`} onClick={() => handleTagClick('freemium')}>{__('Freemium', 'nexter-extension')}</a>
                            <a className={`nxt_category_btn ${filterTag === 'pro' ? 'nxt_active' : ''}`} onClick={() => handleTagClick('pro')}>{__('Pro', 'nexter-extension')}</a>
                        </div>
                        <div className='nxt_right_search_and_btn_group'>
                            <div className='nxt_block_search_box_cover'>
                                <img className='nxt_search_icon' src={plugin_url + 'assets/svg/search_icon.svg'} draggable={false} />
                                <input type='text' placeholder='Search' className='nxt_block_search_box' value={searchBlock} onChange={handleSearchChange} />
                            </div>
                            <div className='nxt_scan_unused_btn_cover'>
                                {unusedBlocksCount == null &&
                                    <button className='nxt_scan_unused_btn nxt_wht_common_btn' onClick={handleScanUnusedBlocks}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none" viewBox="0 0 16 17"><path d="M1.5 6a.5.5 0 0 0 .5-.5V3a.5.5 0 0 1 .5-.5h2.75a.5.5 0 1 0 0-1H2.5A1.5 1.5 0 0 0 1 3v2.5a.5.5 0 0 0 .5.5Zm12-4.5h-2.75a.5.5 0 0 0 0 1h2.75a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 0 1 0V3a1.5 1.5 0 0 0-1.5-1.5Zm1 9.5a.5.5 0 0 0-.5.5V14a.5.5 0 0 1-.5.5h-2.75a.5.5 0 0 0 0 1h2.75A1.5 1.5 0 0 0 15 14v-2.5a.5.5 0 0 0-.5-.5Zm-9.25 3.5H2.5A.5.5 0 0 1 2 14v-2.5a.5.5 0 0 0-1 0V14a1.5 1.5 0 0 0 1.5 1.5h2.75a.5.5 0 0 0 0-1ZM14.5 8h-13a.5.5 0 1 0 0 1h13a.5.5 0 0 0 0-1Z" /></svg>
                                        {__('Scan Unused Blocks', 'nexter-extension')}
                                    </button>
                                }
                                {unusedBlocksCount !== null &&
                                    <>
                                        <button className='nxt_disable_unused' onClick={handledisableUnused}>
                                            <img className='nxt_scan_icon' src={plugin_url + 'assets/svg/disblock.svg'} draggable={false} />
                                            {__('Disable Unused Blocks', 'nexter-extension')}
                                        </button>
                                        <div className={'nxt_unused_widgets_numbers'}>{__(`${unusedBlocksCount} Unused Blocks found`, 'nexter-extension')}</div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>

                    <div className='the_plus_categories_strip_cover_main nxt_second_strip' ref={stripRef}>
                        <div className='nxt_categories_btns_cover' onMouseDown={handleMouseDown}>
                            {blockCate.map((category, index) => (
                                <a
                                    key={index}
                                    className={`nxt_category_btn ${filterCate === category ? 'nxt_active' : ''}`}
                                    onClick={() => handleCategoryClick(category)}
                                >
                                    {__(category, 'nexter-extension')}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
                {!hasResults &&
                    <NosearchHtml />
                }
                {blockCate.map((category, index) => {
                    const filteredBlocks = (nxtext_ajax_object?.dashData?.blockList) ? Object.keys(nxtext_ajax_object.dashData.blockList)
                        .filter(blockId => filterBlocks(nxtext_ajax_object.dashData.blockList[blockId]) && nxtext_ajax_object.dashData.blockList[blockId].block_cate === category) : [];

                    if (filteredBlocks.length === 0) {
                        return null;
                    }

                    return (
                        <div key={index} id={category.toLowerCase()} className='nxt_category_wise_widgets_management_section_cover'>
                            <div className='nxt_category_wise_widgets_manage_cover'>
                                <div className='nxt_blocks_heading_info_group'>
                                    <h3 className='nxt_block_category_heading'>{category}</h3>
                                    <div className='nxt_category_quick_info'>
                                        <span className='nxt_total_widget_numbers'> {getCategoryCounts(category).totalBlocks + __(' Total Blocks', 'nexter-extension')}</span> •
                                        <span className='nxt_active_widget_numbers'> {getCategoryCounts(category).activeBlocks + __(' Active', 'nexter-extension')}</span>
                                    </div>
                                </div>
                            </div>
                            <div className={'nxt_block_boxes_cover ' + (((nxtext_ajax_object.pro && nxtext_ajax_object.tpgb_pro == undefined) || (nxtext_ajax_object.tpgb_pro == "1")) ? '' : 'nxt-block-pro')}>
                                {filteredBlocks.map((blockId, index) => {
                                    const block = nxtext_ajax_object.dashData.blockList[blockId];

                                    let w_unique, site_url, w_title, wdk_uniqueId, wdk_type = '';
                                    if (nxtext_ajax_object.dashData.blockList[blockId]['w_unique']) {
                                        w_unique = nxtext_ajax_object.dashData.blockList[blockId]['w_unique'];

                                        if (w_unique) {
                                            let path_name = window?.location?.pathname || '';
                                            site_url = `${window.location.origin}${path_name}?page=wdesign-kit#/theplus_popup?id=${w_unique}`;
                                        }

                                    }

                                    w_title = nxtext_ajax_object.dashData.blockList[blockId]['label'];
                                    wdk_uniqueId = nxtext_ajax_object.dashData.blockList[blockId]['uniqueId'];
                                    wdk_type = nxtext_ajax_object.dashData.blockList[blockId]['w_type'];

                                    return (
                                        <div key={blockId} className={'nxt_particular_widget_manage_box block-' + (category !== "WDesignKit" ? block.tag : '') + (category === "WDesignKit" ? " nxt_wdesign_block_list" : "")}>
                                            <div className='nxt_block_inner_left'>
                                                <div className={`nxt_block_sm_tag nxt_category_tag`}>{__(block.tag.toUpperCase(), 'nexter-extension')}</div>
                                                <div className='nxt_block_name'>
                                                    {block.label}
                                                    {block.pro && <span className='nxt_block_sm_tag nxt_block_name_hint_text'>{__('New', 'nexter-extension')}</span>}
                                                </div>
                                                {(block.demoUrl || block.docUrl) &&
                                                    <div className='nxt_about_widget_quick_links_cover'>
                                                        {!(nxtext_ajax_object.dashData.whiteLabel?.nxt_help_link == 'on') &&
                                                            <>
                                                                {block.demoUrl && <a target="_blank" rel="noopener noreferrer" href={block.demoUrl} className='nxt_quick_link'>{__('Live Demo', 'nexter-extension')}</a>}
                                                                {block.docUrl && <a target="_blank" rel="noopener noreferrer" href={block.docUrl} className='nxt_quick_link'>{__('Read Docs', 'nexter-extension')}</a>}
                                                            </>
                                                        }

                                                    </div>
                                                }
                                            </div>
                                            <div className='nxt_block_inner_toggle' onClick={block.tag == 'pro' && !((nxtext_ajax_object.pro && nxtext_ajax_object.tpgb_pro == undefined) || (nxtext_ajax_object.tpgb_pro == "1")) && category !== "WDesignKit" ? () => proModel() : null}>
                                                {category !== 'WDesignKit' && !isLoading &&
                                                    <div className="nxt_block_toggle_btn_cover">
                                                        <input
                                                            className="nxt_toggle_btn"
                                                            type="checkbox"
                                                            checked={blockStates[blockId]}
                                                            onChange={(e) => handleToggleBlock(e, blockId)}
                                                            id={`toggle-${blockId}`}
                                                            disabled={!((nxtext_ajax_object.pro && nxtext_ajax_object.tpgb_pro == undefined) || (nxtext_ajax_object.tpgb_pro == "1")) && block.tag === 'pro'}
                                                        />
                                                        <label className="switch-label" htmlFor={`toggle-${blockId}`}>
                                                            <span className="switch-button"></span>
                                                        </label>
                                                        <img className='nxt_toggle_lock_icon' src={plugin_url + 'assets/svg/nxt_lock_icon.svg'} />
                                                    </div>
                                                }

                                                {category === "WDesignKit" &&
                                                    <>
                                                        {/* WDK Install or not Conditions Apply Here  */}
                                                        {wdadded !== true ?
                                                            <div className="nxt_block_inner_toggle" onClick={openWDKPopup}>
                                                                <div className="nxt_block_toggle_btn_cover">
                                                                    <label className="nxt-wid-tgl-btn-cover">
                                                                        <div className="nxt-wkit-download-template">{downloadSVG}</div>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            :
                                                            <>
                                                                {wdk_type ? (
                                                                    <div className='nxt_block_inner_toggle'>
                                                                        <div className="nxt_block_toggle_btn_cover">
                                                                            <input
                                                                                className="nxt_toggle_btn"
                                                                                type="checkbox"
                                                                                checked={wdk_type === 'Publish'}
                                                                                onChange={(e) => Handle_widget(e.target.checked, wdk_uniqueId, w_title)}
                                                                                id={`toggle-${blockId}`}
                                                                            />
                                                                            <label className="switch-label" htmlFor={`toggle-${blockId}`}>
                                                                                <span className="switch-button"></span>
                                                                            </label>
                                                                            <img className='nxt_toggle_lock_icon' src={`${plugin_url}assets/svg/nxt_lock_icon.svg`} />
                                                                        </div>
                                                                    </div>) : (
                                                                    <div className="nxt_block_inner_toggle">
                                                                        <div className="nxt_block_toggle_btn_cover">
                                                                            <label className="nxt-wid-tgl-btn-cover">
                                                                                <div className="nxt-wkit-download-template"
                                                                                    onClick={() => {
                                                                                        setSelectedWUnique(site_url);
                                                                                        WsetShowPopup('download');
                                                                                        setwdBlockID(wdk_uniqueId);
                                                                                        setwdkloader(true);
                                                                                        setIsAfterWDKPopupVisible(true);
                                                                                    }}>
                                                                                    {downloadSVG}
                                                                                </div>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </div>
                                            {unusedBlocksCount !== null && category !== 'Extras' && category !== "WDesignKit" &&
                                                <div className='nxt_block_used_top_tip'>
                                                    {usageData[blockId] === 0 ? __('Unused', 'nexter-extension') : __('Used', 'nexter-extension')}
                                                </div>
                                            }
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}

                <ToastContainer
                    position="top-right"
                    autoClose={500}
                    limit={1}
                    closeOnClick={true}
                    closeButton={false}
                    pauseOnHover={false}
                    hideProgressBar={true}
                    transition={Slide}
                />
                </>
                : 
                <>
                <section className="nxt-install-blocks-sec">
                    <div className='nxt-ins-block-cover'>
                        <div className="nxt-ins-block-inner">
                            <span className="badge">
                                {__('90+ WordPress Gutenberg Blocks', 'nexter-extension')}
                            </span>
                            <h1 className="nxt-ins-heading">
                                {__(
                                    'Unlock the Complete Potential of Nexter by Enabling Nexter Gutenberg Blocks',
                                    'nexter-extension'
                                )}
                            </h1>
                            <p className='nxt-ins-desc'>
                                {__(
                                    'Build professional, fast, and beautiful WordPress sites without relying on heavy page builders. Nexter Blocks work natively with Gutenberg, giving you everything you need while keeping your site lightweight and performance-focused.',
                                    'nexter-extension'
                                )}
                            </p>
                            <div className="nxt-ins-btns">
                                
                                <button onClick={(e) => nxtInstallCall(e, true,"the-plus-addons-for-block-editor")} className="ins-btn-primary">
                                    {nxtext_ajax_object?.dashData?.tpgbactivate ? __('Activate Nexter Blocks', 'nexter-extension') : __('Install Nexter Blocks Free', 'nexter-extension')}
                                </button>
                                <a href="https://nexterwp.com/nexter-blocks/?utm_source=wpbackend&utm_medium=banner&utm_campaign=nextersettings" rel="noopener noreferrer" target="_blank"  className="ins-btn-outline">
                                    {__('Explore All Features', 'nexter-extension')}
                                </a>
                            </div>
                            <ul className="nxt-feature-list">
                                {features.map((f, i) => (
                                    <li key={i}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" fill="none" viewBox="0 0 14 15"><path fill="#1717cc" d="M6.373.505a7.13 7.13 0 0 0-3.7 1.474c-.535.41-1.228 1.183-1.628 1.813a9.6 9.6 0 0 0-.63 1.29c-.135.367-.28.931-.351 1.367-.085.534-.085 1.547 0 2.081a6.9 6.9 0 0 0 .65 2.04c.361.738.736 1.26 1.34 1.866a6.5 6.5 0 0 0 1.866 1.34 7 7 0 0 0 2.042.649c.534.084 1.548.084 2.083 0a7 7 0 0 0 2.041-.65 6.5 6.5 0 0 0 1.867-1.339 6.5 6.5 0 0 0 1.34-1.865c.241-.49.362-.81.493-1.304C13.96 8.61 14 8.251 14 7.49c0-.762-.041-1.12-.214-1.778a6.3 6.3 0 0 0-.493-1.304 6.5 6.5 0 0 0-1.34-1.865 6.5 6.5 0 0 0-1.867-1.34A6.8 6.8 0 0 0 8.058.56C7.655.497 6.756.467 6.373.505"/><path fill="#fff" d="M10.673 4.482c.137.044.348.249.406.4a.76.76 0 0 1-.017.561c-.088.178-4.599 4.654-4.802 4.766a.66.66 0 0 1-.624-.003c-.116-.06-2.193-1.92-2.547-2.279a.68.68 0 0 1-.205-.506c.005-.414.31-.693.72-.666.1.008.22.033.267.06.074.036 1.458 1.282 1.907 1.712l.129.126 2.05-2.046c1.126-1.123 2.086-2.062 2.135-2.087a.7.7 0 0 1 .58-.038"/></svg>
                                        {__(f, 'nexter-extension')}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="nxt-ins-img nxt-blocks">
                            <img
                                src={plugin_url + "assets/images/install-nexter-blocks.png"}
                                alt={__('Nexter Blocks', 'nexter-extension')}
                            />
                        </div>
                    </div>
                    
                </section>
                </>
                }
                
            </div>
        </>
    );
};

export default Blocks;